// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import stylesDef from './styles';

interface IDragPreviewProps {
  folder: IFolder;
}

// The picked-up folder card drawn by the page's drag overlay while a folder is being reordered.
// Presentation only: no drag hooks (the in-flow card owns those), no menu, no dialogs.
const DragPreview = ({ folder }: IDragPreviewProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme, false);
  const projectCount = folder.projectCount ?? 0;

  return (
    <Box sx={{ ...styles.mainContiner, ...styles.preview }}>
      <Box sx={styles.folderItemContainer}>
        <Box sx={styles.folderIconContainer}>
          <FolderOutlinedIcon />
        </Box>
        <Box sx={styles.folderDetails}>
          <Typography variant="h5" sx={styles.folderNameText}>
            {folder.name ?? ''}
          </Typography>
          <Typography variant="body2" sx={styles.projectCount}>{`${projectCount} ${projectCount > 1 ? 'Projects' : 'Project'}`}</Typography>
        </Box>
      </Box>
      <Box sx={styles.previewHandle}>
        <BackHandOutlinedIcon fontSize="small" />
      </Box>
    </Box>
  );
};

export default DragPreview;
